// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1dfea8fa","455":"907f79a0","977":"714b4632"}[chunkId] + ".chunk.js";
};